console.log("JS rodando no tema WordPress com Gulp + Tailwind 🎉");